<template>
  
    <v-container>
        <h5>{{fox}}</h5>
        <v-data-table
            v-bind:headers="headers"
            :items="locations"
            hide-actions
            class="elevation-1"
            >
                <template slot="items" scope="props">
                <td>{{ props.item.time | moment("MMMM Do YYYY, h:mm:ss a") }}</td>
                <td>{{ props.item.lat }}</td>
                <td>{{ props.item.lng }}</td>
                <td>{{ props.item.isHunt }}</td>
                <td  class="text-xs-right"><a @click="remove_location(props.item)"><v-icon>delete_forever</v-icon></a></td>
            </template>pois
        </v-data-table>
    </v-container>
</template>

<script>

export default {
  name: 'fox-location-history-table',
  props: ['fox'],
  data() {
      return {
          headers: [
              {text: 'Tijd', align: 'left', sortable: false},
              {text: 'Latitude', align: 'left', sortable: false},
              {text: 'Longitude', align: 'left', sortable: false},
              {text: 'Hunt', align: 'left', sortable: false},
              {text: '', align: 'right', sortable: false},
          ]
      }
  },
  computed: {
      locations() {
          return this.$store.getters[this.fox];
      }
  },
  methods: {
      remove_location(location) {
          this.$store.dispatch('REMOVE_FOX_LOCATION', location);
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FoxLocationHistoryTable.vue